import * as moment from 'moment';
import 'moment-timezone';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { DataexchangeService } from '../../../services/dataexchange.service';
import { HttpClient } from '@angular/common/http';
import { OrderPipe } from '../../../helpers/order.pipe';
import { StateService } from '../../../services/state.service';
import { Subscription } from 'rxjs';
import {
  getCurrencyPairsSelector,
  getSwapHistorySelector,
} from '../../../store/state/selectors/matchboard.selectors';
import { Store } from '@ngrx/store';
import { MatchBoardState } from '../../../store/state/reducers/matchboard.reducers';
import { SwapHistory } from '../../../models/swap-history.model';
import { Json } from '../../../models/Json';
import { CurrencyDto } from '../../../models/CurrencyDto';

@Component({
  selector: 'app-swap-history',
  templateUrl: './swap-history.component.html',
})
export class SwapHistoryComponent implements OnInit, OnDestroy {
  subscriptions: Array<Subscription>;

  from: Date;
  to: Date;

  bsValue = new Date(
    new Date().getFullYear(),
    new Date().getMonth(),
    new Date().getDate(),
    0,
    0,
    0,
  );
  bsRangeValue: Date[];
  maxDate = new Date(
    new Date().getFullYear(),
    new Date().getMonth(),
    new Date().getDate(),
    23,
    59,
    59,
  );
  minDate = new Date(2019, 0o1, 0o1, 23, 59, 59);

  tzlocal = moment.tz.guess();
  serverTimeOffset = moment.tz('America/New_York').utcOffset(); // -300  New York UTC-5 hours
  localTimeoffset = moment.tz(this.tzlocal).utcOffset(); // 60
  localDif = this.localTimeoffset / 60;
  timeOffset =
    (this.serverTimeOffset - this.localTimeoffset) / 60 + this.localDif; // 420 / 7
  timeOff = this.timeOffset * 60;

  public today = Date.now();

  SwapHistoryColumns: SwapHistory[] = [];

  order: {
    timestamp?: number;
  } = {
    timestamp: -1,
  };
  reverse: boolean = false;
  collection: any[] = this.SwapHistoryColumns;
  sortedCollection: any[];

  currencyPairsJson: Json<string, CurrencyDto>;

  constructor(
    private httpService: HttpClient,
    private orderPipe: OrderPipe,
    private stateService: StateService,
    private dataexchangeService: DataexchangeService,
    private readonly store: Store<MatchBoardState>,
  ) {
    this.maxDate.setDate(this.maxDate.getDate());
    this.bsRangeValue = [this.bsValue, this.maxDate];
    this.sortedCollection = orderPipe.transform(this.collection, 'timestamp');
    this.subscriptions = new Array<Subscription>();
  }

  setOrder(value: string) {
    if (!Object.keys(this.order).includes(value) || this.order[value] === 0) {
      this.order[value] = 1;
      return;
    }

    if (this.order[value] === 1) {
      this.order[value] = -1;
      return;
    }
    this.order[value] = 0;
  }

  Arr = Array;
  num: number = 5;

  ngOnInit() {
    this.from = new Date();
    this.to = new Date();

    this.store.select(getSwapHistorySelector).subscribe((swapHistory) => {
      this.SwapHistoryColumns = swapHistory;
    });
    this.store.select(getCurrencyPairsSelector).subscribe((currencyPairs) => {
      this.currencyPairsJson = new Json(currencyPairs, 'sixLetterCode');
    });
  }

  getClass(property: string) {
    if (!this.order[property] || this.order[property] === 0) {
      return 'icon-with';
    }
    if (this.order[property] === -1) {
      return 'fa-chevron-up';
    }
    return 'fa-chevron-down';
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach((s) => s.unsubscribe());
  }
}
